import useInView from 'react-cool-inview'
import cn from 'classnames'
import { FC } from 'react'
// Components
import CardCategoriesMobile from '../cardCategoriesMobile/cardCategoriesMobile'
import CategoryCard from '../home/CategoryCard'
// Utils
import styles from './RelatedCategories.module.scss'

interface RelatedCategoriesProps {
  breedCategories: any
  isLanding: boolean
}

const RelatedCategories: FC<RelatedCategoriesProps> = ({
  breedCategories,
  isLanding,
}) => {
  const { observe, inView } = useInView({
    unobserveOnEnter: true,
  })

  return (
    <div className={styles.relaterCategoriesContainer}>
      <h2>Explore Related Dog Categories </h2>

      <div className={cn(styles.box, styles.desktop)}>
        {breedCategories.map((c, i) => (
          <CategoryCard key={i} c={c} isLanding={isLanding} />
        ))}
      </div>
      <div className={cn(styles.box, styles.mobile)} ref={observe}>
        {inView && (
          <CardCategoriesMobile
            categories={breedCategories}
            isLanding={isLanding}
          />
        )}
      </div>
    </div>
  )
}

export default RelatedCategories
